import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import Link from 'components/consumer/Link';
import PDPMobileCarousel from 'components/consumer/PDP/PDPMobileCarousel';
import MobileModal from 'components/consumer/MobileModal';
import useIsBrowser from 'hooks/useIsBrowser';
import { GALLERY_IMAGE_LOCATION, GALLERY_INTERACTION } from 'data-hooks/useEvents/pdpGalleryEventConstants';
import PDPDimensionsContent from '../PDPDimensionsContent';
const PDPMobileStudioCampaignLogo = loadable(() => import('./PDPMobileStudioCampaignLogo'));
const PDPMobileStudioPhotoGalleryUI = t0 => {
  const $ = _c(38);
  const {
    enableCrops: t1,
    introVideoId,
    linkTo,
    mode: t2,
    photos: t3,
    productName,
    resetGalleryImageTracking,
    trackGalleryInteracted,
    viewGalleryImageEvent,
    campaign
  } = t0;
  const enableCrops = t1 === undefined ? true : t1;
  const mode = t2 === undefined ? "pdp" : t2;
  let t4;
  if ($[0] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const photos = t4;
  const isPdpMode = mode === "pdp";
  const isGalleryLinked = !isPdpMode && linkTo;
  const GalleryWrapper = isGalleryLinked ? Link : "div";
  const [isDimensionsModalOpen, setIsDimensionsModalOpen] = useState(false);
  const isBrowser = useIsBrowser();
  let t5;
  if ($[2] !== photos || $[3] !== viewGalleryImageEvent) {
    t5 = photo => {
      if (!photo?.src) {
        return;
      }
      const position = photos.findIndex(t6 => {
        const {
          src
        } = t6;
        return src === photo.src;
      });
      if (position === -1) {
        return;
      }
      viewGalleryImageEvent?.({
        imageLocation: GALLERY_IMAGE_LOCATION.LIFESTYLE,
        imageFilename: photo.src.split("/").pop() || "",
        totalImages: photos.length,
        position
      });
    };
    $[2] = photos;
    $[3] = viewGalleryImageEvent;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const reportPhotoViewed = t5;
  let t6;
  if ($[5] !== isGalleryLinked) {
    t6 = classNames("PDPMobileStudioPhotoGalleryUI", {
      "block mt-[5px]": isGalleryLinked
    });
    $[5] = isGalleryLinked;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isGalleryLinked ? linkTo : null;
  let t8;
  if ($[7] !== campaign || $[8] !== isBrowser) {
    t8 = isBrowser ? <PDPMobileStudioCampaignLogo campaign={campaign} /> : null;
    $[7] = campaign;
    $[8] = isBrowser;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== reportPhotoViewed || $[11] !== resetGalleryImageTracking || $[12] !== trackGalleryInteracted) {
    t9 = photo_0 => {
      resetGalleryImageTracking?.();
      trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_OPENED);
      reportPhotoViewed(photo_0);
    };
    $[10] = reportPhotoViewed;
    $[11] = resetGalleryImageTracking;
    $[12] = trackGalleryInteracted;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== trackGalleryInteracted) {
    t10 = () => trackGalleryInteracted?.(GALLERY_INTERACTION.LIFESTYLE_GALLERY_CLOSED);
    $[14] = trackGalleryInteracted;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== enableCrops || $[17] !== introVideoId || $[18] !== isPdpMode || $[19] !== photos || $[20] !== productName || $[21] !== reportPhotoViewed || $[22] !== t10 || $[23] !== t9) {
    t11 = <PDPMobileCarousel enableCrops={enableCrops} isHero={true} photos={photos} videoId={introVideoId} productName={productName} showFavoriteButton={isPdpMode} onAfterSlide={reportPhotoViewed} onOpenFullScreenGallery={t9} onCloseFullScreenGallery={t10} onPhotoViewed={reportPhotoViewed} displayShownIn={isPdpMode} showARIcon={true} zoomOnClick={isPdpMode} />;
    $[16] = enableCrops;
    $[17] = introVideoId;
    $[18] = isPdpMode;
    $[19] = photos;
    $[20] = productName;
    $[21] = reportPhotoViewed;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== GalleryWrapper || $[26] !== t11 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
    t12 = <GalleryWrapper className={t6} to={t7}>{t8}{t11}</GalleryWrapper>;
    $[25] = GalleryWrapper;
    $[26] = t11;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => {
      setIsDimensionsModalOpen(false);
    };
    t14 = <PDPDimensionsContent />;
    $[31] = t13;
    $[32] = t14;
  } else {
    t13 = $[31];
    t14 = $[32];
  }
  let t15;
  if ($[33] !== isDimensionsModalOpen) {
    t15 = <MobileModal isOpen={isDimensionsModalOpen} title="Dimensions" isFullHeight={true} onClose={t13}>{t14}</MobileModal>;
    $[33] = isDimensionsModalOpen;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t12 || $[36] !== t15) {
    t16 = <>{t12}{t15}</>;
    $[35] = t12;
    $[36] = t15;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
PDPMobileStudioPhotoGalleryUI.propTypes = {
  enableCrops: PropTypes.bool,
  introVideoId: PropTypes.string,
  linkTo: PropTypes.string,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  photos: PropTypes.arrayOf(PropTypes.object),
  productName: PropTypes.string,
  resetGalleryImageTracking: PropTypes.func,
  trackGalleryInteracted: PropTypes.func,
  viewGalleryImageEvent: PropTypes.func,
  campaign: PropTypes.string
};
export default PDPMobileStudioPhotoGalleryUI;